module.exports = __webpack_public_path__ + "5e9b5403756ef67c59045724c203441f.woff2";